import React, { useRef, useEffect, memo } from 'react';
import styles from './styles.module.scss';

interface AnimatedLogoProps {
  className?: string;
  loop?: boolean;
  width?: number;
  height?: number;
  preload?: boolean;
}

const AnimatedLogo: React.FC<AnimatedLogoProps> = ({
  className,
  loop = false,
  width = 239,
  height = 100,
  preload = false,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      // Enable hardware acceleration for better LCP
      videoRef.current.style.transform = 'translateZ(0)';
      videoRef.current.playsInline = true;
      videoRef.current.muted = true;
      videoRef.current.autoplay = true;

      // Disable unnecessary features for better performance
      videoRef.current.disablePictureInPicture = true;
      videoRef.current.disableRemotePlayback = true;
    }
  }, []);

  return (
    <>
      <div className={`${styles.animatedLogoWrapper} ${className || ''}`}>
        <video
          ref={videoRef}
          loop={loop}
          muted
          autoPlay
          playsInline
          className={styles.videoPlayer}
          preload={preload ? 'auto' : 'none'}
          width={width}
          height={height}
        >
          <source
            src={`${process.env.baseUrl}/images/animated_logo.webm`}
            type='video/webm'
          />
          <source
            src={`${process.env.baseUrl}/videos/animated_logo.mp4`}
            type='video/mp4'
          />
        </video>
      </div>
    </>
  );
};

export default memo(AnimatedLogo);
